// Format ISO date (YYYY-MM-DD) to Italian format (DD/MM/YYYY)
export function formatDate(dateStr) {
  if (!dateStr) return "-";
  const parts = dateStr.split("T")[0].split("-");
  if (parts.length !== 3) return dateStr;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

// Format date + time
export function formatDateTime(dateStr, timeStr) {
  const d = formatDate(dateStr);
  if (!timeStr) return d;
  return `${d} ${timeStr}`;
}
